import React from 'react';

import {
    Avatar,
    Box,
    Card,
    CardContent,
    CardMedia,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography,
    useMediaQuery,
} from '@material-ui/core';

import {
    makeStyles,
    useTheme,
} from '@material-ui/core/styles';

import {
    merge as lodashMerge
} from 'lodash';





//
// Style propre au composant
//
// ATTENTION : ici, il est nécessaire de définir 'useStyle' comme une fonction retournant
// le résultat de 'makestyle' et non pas directement comme le résultat de 'makestyle'. En
// effet, la valeur retournée par 'makeStyles' doit être recalculée à chaque rendu, sinon
// les valeurs associées aux "media queries" semblent ne pas être mises à jour mais
// uniquement la partie 'common' (les 'media query' semblent ne pas être recalculées)
//
const useStyles = () => makeStyles((theme) => ({

    contentOrganisationChartRoot: style => ({
        ...style.contentOrganisationChartRoot.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartRoot.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartRoot.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartRoot.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartRoot.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartRoot.xl,
        },
    }),

    contentOrganisationChartTitle: style => ({
        ...style.contentOrganisationChartTitle.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartTitle.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartTitle.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartTitle.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartTitle.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartTitle.xl,
        },
    }),

    contentOrganisationChartBoxSections: style => ({
        ...style.contentOrganisationChartBoxSections.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartBoxSections.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartBoxSections.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartBoxSections.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartBoxSections.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartBoxSections.xl,
        },
    }),

    contentOrganisationChartBoxSection: style => ({
        ...style.contentOrganisationChartBoxSection.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartBoxSection.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartBoxSection.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartBoxSection.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartBoxSection.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartBoxSection.xl,
        },
    }),

    contentOrganisationChartBoxSectionLabel: style => ({
        ...style.contentOrganisationChartBoxSectionLabel.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartBoxSectionLabel.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartBoxSectionLabel.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartBoxSectionLabel.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartBoxSectionLabel.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartBoxSectionLabel.xl,
        },
    }),

    contentOrganisationChartBoxCards: style => ({
        ...style.contentOrganisationChartBoxCards.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartBoxCards.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartBoxCards.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartBoxCards.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartBoxCards.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartBoxCards.xl,
        },
    }),

    contentOrganisationChartCard: style => ({
        ...style.contentOrganisationChartCard.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartCard.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartCard.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartCard.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartCard.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartCard.xl,
        },
    }),

    contentOrganisationChartCardMedia: style => ({
        ...style.contentOrganisationChartCardMedia.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartCardMedia.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartCardMedia.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartCardMedia.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartCardMedia.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartCardMedia.xl,
        },
    }),

    contentOrganisationChartCardName: style => ({
        ...style.contentOrganisationChartCardName.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartCardName.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartCardName.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartCardName.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartCardName.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartCardName.xl,
        },
    }),

    contentOrganisationChartCardGrade: style => ({
        ...style.contentOrganisationChartCardGrade.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartCardGrade.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartCardGrade.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartCardGrade.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartCardGrade.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartCardGrade.xl,
        },
    }),

    contentOrganisationChartListItem: style => ({
        ...style.contentOrganisationChartListItem.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartListItem.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartListItem.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartListItem.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartListItem.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartListItem.xl,
        },
    }),

    contentOrganisationChartAvatar: style => ({
        ...style.contentOrganisationChartAvatar.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartAvatar.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartAvatar.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartAvatar.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartAvatar.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartAvatar.xl,
        },
    }),

    contentOrganisationChartAvatarImg: style => ({
        ...style.contentOrganisationChartAvatarImg.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentOrganisationChartAvatarImg.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentOrganisationChartAvatarImg.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentOrganisationChartAvatarImg.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentOrganisationChartAvatarImg.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentOrganisationChartAvatarImg.xl,
        },
    }),
}));





//
// Composant permettant d'afficher un trombinoscope
//
export const ContentOrganisationChart = ({ title, params, style, data, ...props }) => {


    ////////////////////////////////////////
    //                                    //
    //          Gestion du style          //
    //                                    //
    ////////////////////////////////////////

    // On crée le style
    const theme = useTheme();

    // On fusionne les styles récupérés avec un template par défaut
    // pour être sûr que toutes les propriétés soient disponibles
    // Les valeurs contenues dans le style 'style' (fournies par le serveur)
    // écraseront les valeurs par défaut
    //
    // ATTENTION : ici, 'useStyles' est une fonction retournant le résultat de
    // 'makeStyles' (retournant également une fonction) d'où le double appel.
    // Cette étape supplémentaire est nécessaire pour les valeurs associées aux
    // "media query" soient correctement mises à jour
    //
    const classes = useStyles()(
        lodashMerge(
            {
                contentOrganisationChartRoot: {
                    common: {},
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentOrganisationChartTitle: {
                    common: {},
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentOrganisationChartBoxSections: {
                    common: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '2rem',
                    },
                    xs: {},
                    sm: {},
                    md: {
                        gap: '5rem',
                    },
                    lg: {
                        gap: '5rem',
                    },
                    xl: {
                        gap: '5rem',
                    },
                },
                contentOrganisationChartBoxSection: {
                    common: {
                        display: 'flex',
                        flexDirection: 'column',
                    },
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentOrganisationChartBoxSectionLabel: {
                    common: {
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        marginBottom: '0px',
                        color: theme.palette.primary.contrastText,
                        backgroundColor: theme.palette.primary.light,
                        paddingLeft: theme.spacing(4),
                    },
                    xs: {},
                    sm: {},
                    md: {
                        marginBottom: theme.spacing(4),
                    },
                    lg: {
                        marginBottom: theme.spacing(4),
                    },
                    xl: {
                        marginBottom: theme.spacing(4),
                    },
                },
                contentOrganisationChartBoxCards: {
                    common: {
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        justifyContent: 'flex-start',
                        gap: '1rem',
                    },
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentOrganisationChartCard: {
                    common: {
                        display: 'flex',
                        flexDirection: 'column',
                        width: '15rem',
                    },
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentOrganisationChartCardMedia: {
                    common: {
                        objectFit: 'cover',
                        maxHeight: '15rem',
                        objectPosition: 'top center',
                    },
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentOrganisationChartCardName: {
                    common: {
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                    },
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentOrganisationChartCardGrade: {
                    common: {
                        fontSize: '1rem',
                        fontStyle: 'italic',
                        marginBottom: theme.spacing(2),
                    },
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentOrganisationChartListItem: {
                    common: {
                        gap: theme.spacing(2),
                    },
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentOrganisationChartAvatar: {
                    common: {
                        width: '20vw',
                        height: '30vw',
                    },
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentOrganisationChartAvatarImg: {
                    common: {},
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
            },
            style
        )
    );



    //////////////////////////////////////////
    //                                      //
    //          Rendu du composant          //
    //                                      //
    //////////////////////////////////////////

    // Actuellement, deux modes d'affichage sont disponbiles :
    // > md : mode 'desktop' (grand écran)
    // <= md : mode 'mobile'
    const isMDUp = useMediaQuery(theme => theme.breakpoints.up('md'));


    return (
        <Box
            className={classes.contentOrganisationChartRoot}
        >
            {title &&
                <Typography
                    className={classes.contentOrganisationChartTitle}
                    component="h1"
                    variant="h1"
                >
                    {title}
                </Typography>
            }

            <Box
                className={classes.contentOrganisationChartBoxSections}
            >
                {data.map((section, index_section) =>
                    <Box
                        key={index_section}
                        className={classes.contentOrganisationChartBoxSection}
                    >
                        <Typography
                            className={classes.contentOrganisationChartBoxSectionLabel}
                            component="h2"
                            variant="h6"
                        >
                            {section.section_label}
                        </Typography>


                        {isMDUp ?

                            <Box
                                className={classes.contentOrganisationChartBoxCards}
                            >
                                {section.lst_persons.map((person, index_person) =>
                                    <Card
                                        key={index_person}
                                        className={classes.contentOrganisationChartCard}
                                    >
                                        <CardMedia
                                            className={classes.contentOrganisationChartCardMedia}
                                            component="img"
                                            src={person.photo_resized_src}
                                            srcSet={person.photo_resized_srcset}
                                            sizes="30vw" // TODO : à calculer dynamiquement
                                            title={person.photo_alt}
                                            alt={person.photo_alt}
                                        />
                                        <CardContent>
                                            <Typography
                                                className={classes.contentOrganisationChartCardName}
                                                variant="body2"
                                                color="textPrimary"
                                                component="p"
                                            >
                                                {person.firstname} {person.lastname}
                                            </Typography>
                                            {person.grade &&
                                                <Typography
                                                    className={classes.contentOrganisationChartCardGrade}
                                                    variant="body2"
                                                    color="textSecondary"
                                                    component="p"
                                                >
                                                    {person.grade}
                                                </Typography>
                                            }
                                            {person.activity && <Typography variant="body2" color="textSecondary" component="p">{person.activity}</Typography>}
                                            {person.contact && <Typography variant="body2" color="textSecondary" component="p">{person.contact}</Typography>}
                                            {person.extra_infos && <Typography variant="body2" color="textSecondary" component="p">{person.extra_infos}</Typography>}
                                        </CardContent>
                                    </Card>
                                )}
                            </Box>

                        :

                            <List>
                                {section.lst_persons.map((person, index_person) =>
                                    <ListItem
                                        key={index_person}
                                        className={classes.contentOrganisationChartListItem}
                                        alignItems="flex-start"
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                className={classes.contentOrganisationChartAvatar}
                                                variant="rounded"
                                                src={person.photo_resized_src}
                                                srcSet={person.photo_resized_srcset}
                                                sizes="30vw" // TODO : à calculer dynamiquement
                                                title={person.photo_alt}
                                                alt={person.photo_alt}
                                                imgProps={{ className: classes.contentOrganisationChartAvatarImg }}
                                            />
                                        </ListItemAvatar>

                                        <ListItemText
                                            primary={
                                                <>
                                                    <Typography
                                                        className={classes.contentOrganisationChartCardName}
                                                        variant="body2"
                                                        color="textPrimary"
                                                        component="p"
                                                    >
                                                        {person.firstname} {person.lastname}
                                                    </Typography>
                                                    {person.grade &&
                                                        <Typography
                                                            className={classes.contentOrganisationChartCardGrade}
                                                            variant="body2"
                                                            color="textSecondary"
                                                            component="p"
                                                        >
                                                            {person.grade}
                                                        </Typography>
                                                    }
                                                    {person.activity && <Typography variant="body2" color="textSecondary" component="p">{person.activity}</Typography>}
                                                    {person.contact && <Typography variant="body2" color="textSecondary" component="p">{person.contact}</Typography>}
                                                    {person.extra_infos && <Typography variant="body2" color="textSecondary" component="p">{person.extra_infos}</Typography>}
                                                </>
                                            }
                                        />
                                    </ListItem>
                                )}
                            </List>

                        }
                    </Box>
                )}
            </Box>
        </Box>
    );
}
